import React, { useState } from 'react';
import { connect } from 'react-redux';
import { deepClone } from '../../../../../helpers/objectHelper';
import { simpleButtonHandler } from './SimpleButton.handler';
import { emailActions } from '../../../../../store/actions/cms/email/email.action';
import { HtmlWrapper } from '../../components/HtmlWrapper';
import './SimpleButton.css'
import { toKebabCase } from '../../../../../helpers/cssHelper';
import TextWrapper from '../../components/TextWrapper';
import ContentEditable from "react-contenteditable";

class SimpleButton extends React.Component {
    textOnChange = (text) => {
        const { element, dispatch } = this.props;
        const updatedElement = deepClone(element);
        try {
            updatedElement.style.elementProps.text = text;
        } catch (error) {
            console.log('ERR: COULD NOT SET TEXT')
        }
        updatedElement.content = simpleButtonHandler.elementEditor(updatedElement.style, null);
        dispatch(emailActions.updateEmailElement(updatedElement, null, true, this.props.inherit));
    }
    render() {
        const { element } = this.props;
        return (
            <React.Fragment>
                <tr>
                    <td style={element.style.wrapper}>
                        <table role="presentation" cellSpacing="0" cellPadding="0" border="0" width="100%">
                            <tbody>
                                <tr>
                                    <td >
                                        <table role="presentation" cellSpacing="0" cellPadding="0" border="0" style={{
                                            margin: element.style.styleProps.margin.toString().includes('auto') ? element.style.styleProps.margin + ' !important' : `${element.style.styleProps.margin} auto !important`,
                                            backgroundColor: element.style.wrapper.backgroundColor
                                        }}>
                                            <tbody>
                                                <tr>
                                                    <td  >
                                                        <ContentEditable
                                                            style={{ ...element.style.styleProps, width: element.style.styleProps.minWidth }}
                                                            innerRef={this.contentEditable}
                                                            html={element.style.elementProps.text}
                                                            onChange={e => this.textOnChange(e.target.value)}
                                                            tagName="a"
                                                        />
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </td>
                </tr>
            </React.Fragment >
        )
    }

}
function mapStateToProps(state) {
    return {
        selectedElement: state.email.selectedElement,
        inherit: state.email.inherit
    };
}

export default connect(mapStateToProps)(SimpleButton);